export default __webpack_public_path__ + "static/media/logo.42a4d6f6.png";